// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_02712f2b3b--tooltip--wkvpj"};